export default "__VITE_ASSET__0DWodXIl__"